// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__kbOkO","separator":"Contacts_separator__1wzZW"};